import { useFormat } from '@ideavivat/vivat-2';

import {
  _primaryControls,
  _increment,
  orderNumber,
  orderDate,
  type,
  status,
  customerName,
  /* eslint-disable-next-line */
  area_id,
  address,
  totalWeight,
  remarks,
  lastUpdatedBy,
  updatedAt,
  sortable,
  createdAt,
} from './base';

export default {
  types: {
    _primaryControls,
    _increment,
    orderNumber,
    type,
    createdAt,
    status,
    customerName,
    /* eslint-disable-next-line */
    area_id,
    address,
    totalWeight,
    hub: {
      name: 'สาขา',
      width: '6rem',
      filter: (val: any) => val?.name || '',
    },
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '8rem',
      class: 'text-center',
    },
    deliveryFee: {
      name: 'ค่าจัดส่ง',
      width: '1fr',
      class: 'text-right',
      filter: (val: string, row: any) => (row.item.type === 'LEASED' ? useFormat.number(row.item.fullTruckLoadFee).currency() : useFormat.number(val).currency()),
    },
    remarks,
    lastUpdatedBy,
    updatedAt,
  },
  sortable,
};
